import { produce } from 'immer';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Breadcrumbs from '../../../../../common/widgets/Breadcrumbs';
import { resources } from '../../../resources/resources';
import applicationCrumbs from '../../ApplicationCrumbs';
import PlatformInformation from '../../Common/PlatformInformation';
import MyAccountMenu from '../Common/MyAccountMenu';
import { MultifactorInfo } from './Components/MultifactorInfo';
import {
  PasswordAndMultifactorTabNav,
  PasswordAndMultifactorTabs,
} from './Components/PasswordAndMultifactorTabNav';
import { PasswordChange } from './Components/PasswordChange';

export interface PasswordAndMultifactorState {
  activeTab: PasswordAndMultifactorTabs;
}

export const ChangePasswordPage = () => {
  const { t: translate } = useTranslation();
  const crumbs = applicationCrumbs(translate);
  const initialActiveTab = PasswordAndMultifactorTabs.Password;

  const getActiveTab = (
    activeTabQueryString: string | null,
  ): PasswordAndMultifactorTabs => {
    if (!activeTabQueryString) return initialActiveTab;
    if (activeTabQueryString === PasswordAndMultifactorTabs.Password)
      return PasswordAndMultifactorTabs.Password;
    return PasswordAndMultifactorTabs.Multifactor;
  };

  const [searchParams] = useSearchParams();
  const activeTabQueryString = searchParams.get('activeTab');
  const [state, setState] = useState<PasswordAndMultifactorState>({
    activeTab: getActiveTab(activeTabQueryString),
  } as PasswordAndMultifactorState);

  const onTabChange = (tab: PasswordAndMultifactorTabs) => {
    setState(
      produce(d => {
        d.activeTab = tab;
      }),
    );
  };

  useEffect(() => {
    setState(
      produce(d => {
        d.activeTab = getActiveTab(activeTabQueryString);
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabQueryString]);

  return (
    <>
      <Breadcrumbs
        entries={[crumbs.home, crumbs.accountDashboard, crumbs.changePassword]}
      />
      <section className="section-main section-actions my-account-page change-password-page">
        <div className="container">
          <div className="area-actions">
            <MyAccountMenu />
          </div>
          <div className="area-content">
            <PlatformInformation />
            <div className="panel padding-xl">
              <h1>{translate(resources.menu.passwordChange)}</h1>
              <div className="security-tabs-container">
                <PasswordAndMultifactorTabNav
                  activeTab={state.activeTab}
                  onTabChange={tab => onTabChange(tab)}
                />
              </div>
              {state.activeTab === PasswordAndMultifactorTabs.Password && (
                <PasswordChange />
              )}
              {state.activeTab === PasswordAndMultifactorTabs.Multifactor && (
                <MultifactorInfo />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
